{
  "schemaVersion": 1,
  "evidence": "Pinned original client flow and archive audio. All ordinary props and POW share Sound039 when the use animation begins. Sound008 is the original button activation sound. Later archive candidates; exact 2009 sound/behavior unverified.",
  "ui": {
    "activate": {
      "soundId": "008",
      "url": "/game/audio/prop-sounds/Sound008.wav",
      "duration": 0.46140589569161,
      "sampleRate": 44100,
      "sampleCount": 20348,
      "startOffset": 0.0,
      "trigger": "Enabled ordinary-prop or paper-plane button/shortcut activation attempt, before local use validation"
    },
    "cancel": {
      "soundId": "008",
      "url": "/game/audio/prop-sounds/Sound008.wav",
      "duration": 0.46140589569161,
      "sampleRate": 44100,
      "sampleCount": 20348,
      "startOffset": 0.0,
      "trigger": "Optional prototype deselection button adapter",
      "status": "Generic original button sound; no cancellable prop-selection flow is evidenced in the archived battle client"
    },
    "notEnoughEnergy": null,
    "pow": null
  },
  "battle": {
    "use": {
      "soundId": "039",
      "url": "/game/audio/prop-sounds/Sound039.wav",
      "duration": 1.538843537414966,
      "sampleRate": 44100,
      "sampleCount": 67863,
      "startOffset": 0.0,
      "trigger": "Accepted prop use, when the actor begins the original use-item animation; once per accepted use"
    },
    "pow": {
      "soundId": "039",
      "url": "/game/audio/prop-sounds/Sound039.wav",
      "duration": 1.538843537414966,
      "sampleRate": 44100,
      "sampleCount": 67863,
      "startOffset": 0.0,
      "trigger": "Accepted POW activation via usingSpecialSkill, when the actor begins the same original use-item animation"
    }
  },
  "props": {
    "damage10": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "damage20": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "damage30": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "damage40": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "damage50": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "extra1": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "extra2": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "trident": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "fly": {
      "activateSoundId": "008",
      "useSoundId": "039"
    },
    "ice": {
      "activateSoundId": "008",
      "useSoundId": "039"
    }
  },
  "sounds": {
    "008": {
      "url": "/game/audio/prop-sounds/Sound008.wav",
      "duration": 0.46140589569161,
      "sampleRate": 44100,
      "sampleCount": 20348,
      "startOffset": 0.0
    },
    "039": {
      "url": "/game/audio/prop-sounds/Sound039.wav",
      "duration": 1.538843537414966,
      "sampleRate": 44100,
      "sampleCount": 67863,
      "startOffset": 0.0
    }
  },
  "rejectionRule": "An enabled activation may already play Sound008 before EmptyEnergy is returned; no separate rejection sound or Sound039 on failed use. Disabled/hidden ordinary prop buttons return before Sound008.",
  "powRule": "The archived DanderBar has no separate activation click sound; successful POW uses the shared Sound039 effect. Firing the weapon remains governed by weapon-audio.json."
}
